import React from "react"

import { Element, Image } from "components/shared/base"
import {
  PrismicHomepageDataBodyFullWidthImagePrimary
} from "types/__generated__/gatsby-graphql"

export type FullWidthImageProps = PrismicHomepageDataBodyFullWidthImagePrimary

const FullWidthImage: React.FC<FullWidthImageProps> = ({
  image
}): React.ReactElement | null => {
  if (!image?.alt || !image?.gatsbyImageData) return null

  return (
    <Element textAlign="center" maxWidth="maxWidth" m={["50px auto 0", "70px auto 0"]}>
      <Image
        alt={image.alt}
        image={image.gatsbyImageData}
        width="100%"
      />
    </Element>
  )
}

export default FullWidthImage
